const ItemTypes = {
    CARD: 'card',
    BOX: 'Box',
    SECTION: 'section',
    CONTAINER: 'container'
}

export default ItemTypes;
  
